import React from 'react'
import { SliderProps } from './Slider.types'
import styles from './Slider.module.scss'
// import cl from 'classnames'
import { Slider as MSlider } from '@material-ui/core'
import { Text2 } from '../Text2'
import { Input } from '../Input'
import { Text1 } from '../Text1'

const SliderComponent = (props: SliderProps) => {
  const {
    label = 'Items',
    min,
    max,
    value,
    onChange,
    onChangeCommitted
  } = props

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number[]) => {
    onChange && onChange(newValue)
  }

  const handleChangeCommitted = (event: React.ChangeEvent<{}>, newValue: number[]) => {
    onChangeCommitted && onChangeCommitted(newValue)
  }

  return (
    <div className={styles.container}>
      <Text2 className={styles.itemsLabel}>{label}</Text2>
      <MSlider
        value={value || [min, max]}
        defaultValue={[min, max]}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        aria-labelledby='range-slider'
        min={min}
        max={max}
        classes={{
          root: styles.root,
          rail: styles.rail,
          track: styles.track,
          thumb: styles.thumb
        }}
      />

      <div className={styles.minMaxContainer}>

        <div>
          <Input
            value={min}
            readOnly
          />
          <Text1>Min</Text1>
        </div>

        <div>
          <Input
            value={max}
            readOnly
          />
          <Text1>Max</Text1>
        </div>

      </div>
    </div>
  )
}

const Slider = SliderComponent
export { Slider }
